import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'
import {http} from 'hiya-common/src/utils/axios'

import {ListItemType} from './commonTypes'

export enum PageTypeEnum {
  auction = 1,
  exploit,
}

export enum ExploitTypeEnum {
  all = 1,
  mine,
}

export enum IsAgreeEnum {
  agree = 1,
  refuse,
}
interface HiyaRes<T> {
  ret: number
  data: T
}
interface GiftInfoType {
  gift_id: number

  avatar: string

  name: string
}

interface AuctionLandInfoType {
  coins: number
  auction_status: 0 | 1 | 2
  start_time: string
  count_down: number
  name: string
  img: string
  island_id: number
  gift_list: Array<GiftInfoType>
  own: ListItemType
  auction_list: Array<ListItemType>
}
interface OwnerType extends ListItemType {
  is_owner: boolean
}
export interface LandExploitInfoType {
  island_id: number
  img: string
  name: string
  total_coins: number
  promote_coins: number
  owner_list: Array<OwnerType>
  count_down: number
}
interface RewardType {
  id: number
  name: string
  avatar: string
  detail: string
}
interface BoxItemType {
  id: number
  count: number
  is_open: boolean
  reward: RewardType
}
export interface OwnExploitInfoType extends LandExploitInfoType {
  my_box_list: Array<BoxItemType>
  box_list_index: number
  gift_list: Array<GiftInfoType>
}
interface InitialStateType {
  land_list: Array<AuctionLandInfoType>
  land_exploit_list: Array<LandExploitInfoType>
  own_exploit_list: Array<OwnExploitInfoType>
  invite_exploit_list?: Array<LandExploitInfoType>
  mineLandIndex: number
}
const initialState: InitialStateType = {
  land_list: [],
  land_exploit_list: [],
  own_exploit_list: [],
  invite_exploit_list: [],
  mineLandIndex: NaN,
}
// 接口文档https://doc2.ixiaochuan.cn/pages/viewpage.action?pageId=25137515
// 拍卖
export const land_auction_list = createAsyncThunk(
  'land_auction_list',
  async (arg, store: any) => {
    const resp = await http.post<HiyaRes<Pick<InitialStateType, 'land_list'>>>(
      '/live/activity/land_auction_list',
      {
        ...store.getState().env.deviceinfo,
      }
    )
    return resp.data.data
  }
)
export const land_exploit_list = createAsyncThunk(
  'land_exploit_list',
  async (arg, store: any) => {
    const resp = await http.post<
      HiyaRes<Pick<InitialStateType, 'land_exploit_list' | 'own_exploit_list'>>
    >('/live/activity/land_exploit_list', {
      ...store.getState().env.deviceinfo,
    })
    return resp.data.data
  }
)
// 开宝箱
export const open_gift = createAsyncThunk(
  'open_gift',
  async (arg: {id: number; island_id: number}, store: any) => {
    const resp = await http.post<HiyaRes<{ret: -1 | 1; err_msg: string}>>(
      '/live/activity/open_gift',
      {
        ...arg,
        ...store.getState().env.deviceinfo,
      }
    )
    return resp.data.data
  }
)

// 邀请页相关参数
interface InviteArgType {
  island_id: number
  receive_id: number
  owner_id?: number
}
export const search_invite = createAsyncThunk(
  'search_invite',
  async (arg: InviteArgType, store: any) => {
    const resp = await http.post<HiyaRes<{ret: -1 | 1; err_msg: string}>>(
      '/live/activity/search_invite',
      {
        owner_id: store.getState().env.deviceinfo.h_m,
        ...arg,
        ...store.getState().env.deviceinfo,
      }
    )
    return resp.data.data
  }
)
export const land_invite = createAsyncThunk(
  'land_invite',
  async (arg: InviteArgType, store: any) => {
    const resp = await http.post<
      HiyaRes<Pick<InitialStateType, 'land_exploit_list'>>
    >('/live/activity/land_invite', {
      owner_id: store.getState().env.deviceinfo.h_m,
      ...arg,
      ...store.getState().env.deviceinfo,
    })
    return resp.data.data
  }
)
interface ReceiveInviArgType extends InviteArgType {
  owner_id: number
  is_recieve: boolean
}
// 是否接收邀请
export const receive_invite = createAsyncThunk(
  'receive_invite',
  async (arg: ReceiveInviArgType, store: any) => {
    const resp = await http.post<HiyaRes<{ret: -1 | 1; err_msg: string}>>(
      '/live/activity/receive_invite',
      {
        ...arg,
        ...store.getState().env.deviceinfo,
      }
    )
    return resp.data.data
  }
)
// 根据show_id查人
export const getVerifyUser = createAsyncThunk(
  'getVerifyUser',
  async (show_id, store: any) => {
    const resp = await http.post('/live/account/get_member_info_by_show_id', {
      show_id,
      ...store.getState().env.deviceinfo,
    })
    return resp.data.data
  }
)
export const TerritoryBattleSlice = createSlice({
  name: 'TerritoryBattle',
  initialState,
  reducers: {
    get_gift: (state, action) => {
      const {island_id, boxId} = action.payload
      state.own_exploit_list.forEach((v) => {
        if (v.island_id === island_id) {
          const boxItem = v.my_box_list.find((item) => item.id === boxId)
          boxItem.is_open = true
        }
      })
      Object.assign(state, {mineLandIndex: island_id})
    },
  },
  extraReducers: (builder) => {
    // get_gift

    builder.addCase(land_auction_list.fulfilled, (state, action) => {
      // 后端回传数组的时候空数组直接给的null
      const ret = {
        land_list: action.payload.land_list || [],
      }
      Object.assign(state, ret)
    })
    builder.addCase(land_exploit_list.fulfilled, (state, action) => {
      const ret = {
        land_exploit_list: action.payload.land_exploit_list || [],
        own_exploit_list: action.payload.own_exploit_list || [],
      }
      Object.assign(state, ret)
    })
    builder.addCase(land_invite.fulfilled, (state, action) => {
      const ret = {
        invite_exploit_list: action.payload.land_exploit_list || [],
      }
      Object.assign(state, ret)
    })
  },
})
export const TerritoryBattleActions = TerritoryBattleSlice.actions

export default TerritoryBattleSlice.reducer
